import { useQuery } from '@tanstack/react-query'
import { getOfferDetail } from 'tripPlanner/api'
import * as OfferDetailKeys from 'tripPlanner/hooks/reactQueryKeys/offerDetail'

const OFFER_DETAIL_STALE_TIME = 10 * 60 * 1000

interface UseOfferDetailsOptions {
  offerId: string | undefined
  region: string
  offerType?: string
  accommodationPropertyId?: string
  checkIn?: string
  checkOut?: string
  enabled?: boolean
}

export default function useOfferDetails({
  offerId,
  region,
  offerType,
  accommodationPropertyId,
  checkIn,
  checkOut,
  enabled = true,
}: UseOfferDetailsOptions) {
  const queryResult = useQuery({
    queryKey: OfferDetailKeys.detail(
      offerId ?? '',
      region,
      accommodationPropertyId,
      offerType,
      checkIn,
      checkOut,
    ),
    queryFn: () =>
      getOfferDetail(offerId!, region, offerType, accommodationPropertyId, checkIn, checkOut),
    enabled: enabled && !!offerId,
    staleTime: OFFER_DETAIL_STALE_TIME,
  })

  return {
    offerDetail: queryResult.data,
    isLoading: queryResult.isLoading && queryResult.fetchStatus !== 'idle',
    isError: queryResult.isError,
    refetch: queryResult.refetch,
  }
}
